import { DialogFooter as ReactDialogFooter } from "@certn/cascadia-react/components/modal/DialogFooter";
import { memo } from "react";

import { CascadiaDialogFooterProps } from "./types";

export const DialogFooter = memo(function (props: CascadiaDialogFooterProps) {
  return <ReactDialogFooter {...props} />;
});
